import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';

import AppLoader from '@/components/AppLoader';

const CheckoutCancelled = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('co-redirect');
    const destination = redirect?.startsWith('/') ? redirect : '/home';
    route(destination);
  }, []);

  return <AppLoader />;
};

export default CheckoutCancelled;
